import { render, staticRenderFns } from "./GetPdfFile.vue?vue&type=template&id=5a253c5a&scoped=true"
import script from "./GetPdfFile.vue?vue&type=script&lang=js"
export * from "./GetPdfFile.vue?vue&type=script&lang=js"
import style0 from "./GetPdfFile.vue?vue&type=style&index=0&id=5a253c5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a253c5a",
  null
  
)

export default component.exports